// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__4QUfM","legacyBtn":"MutateMid_legacyBtn__3uxc0"};